// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FeedbackCard from './../../../FeedbackCard';
import { TableCell } from '../TableCell';
import UndrawNoData from '../../../Illustrations/Undraw/NoData';
import UndrawNoDataAlt from '../../../Illustrations/Undraw/NoDataAlt';
import { Heading } from '../../../Typography';

export const EmptyStateContainer = styled(({ ...rest }) => <div {...rest} />)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1.33rem 2rem 1.33rem;
`;

export const TableEmptyState = ({ cols, error, ...props }) => {
    const a11yProps = {};

    return (
        <TableCell colSpan={cols}>
            <EmptyStateContainer {...a11yProps} {...props}>
                {RenderEmptyStateContent({ ...props })}
            </EmptyStateContainer>
        </TableCell>
    );
};

TableEmptyState.propTypes = {
    cols: PropTypes.number,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.string]),
    customlabel: PropTypes.string,
    imageSize: PropTypes.number,
    label: PropTypes.string,
    labelfontsize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    query: PropTypes.string
};

TableEmptyState.defaultProps = {
    error: false,
    query: ``
};

export const RenderEmptyStateContent = ({
    cols,
    error,
    imageSize,
    label,
    labelfontsize,
    customlabel,
    query,
    ...rest
}) => {
    if (error) {
        return <FeedbackCard error={error} />;
    }

    if (query) {
        return (
            <>
                <UndrawNoData height={`${imageSize ?? 11.17}rem`} />
                <Heading size={labelfontsize ?? 700}>{customlabel ?? `No matching records found`}</Heading>
            </>
        );
    }

    return (
        <>
            <UndrawNoDataAlt height={`${imageSize ?? 11.17}rem`} />
            <Heading size={labelfontsize ?? 700}>{customlabel ?? `No ${label} available.`}</Heading>
        </>
    );
};

RenderEmptyStateContent.propTypes = { ...TableEmptyState.propTypes };
